export default "__VITE_PUBLIC_ASSET__1091f15c__"